import { StyleSheet } from 'react-native';
import { dimensions } from '../../../../styles';

export default StyleSheet.create({
  initialTabLayout: { height: 0, width: dimensions.width },
});
